import { useTranslation } from 'react-i18next';
import {
  ExactTag,
  RegularTag,
  VerifiedIcon,
} from '../explainability-info-menu.styled';
import STRING_KEYS from '../../../../../language/keys';
import HeaderSection from '../sections/header-section/header-section.component';
import BaseSection from '../sections/base-section/base-section.component';
import {
  CompanyFundingStageTagIcon,
  Container, HeaderDescription, TagContainer,
} from './company-funding-stage-info-menu.styled';

const CompanyFundingStageInfoMenu = ({
  isExactFundingStage = false,
  fundingStage,
  companyName,
}: CompanyFundingStageInfoMenuProps): JSX.Element => {
  const { t: translate } = useTranslation();
  const Tag = isExactFundingStage ? ExactTag : RegularTag;

  return (
    <Container isExactFundingStage={ isExactFundingStage }>
      <>
        <HeaderSection
          title={ translate(STRING_KEYS.COMPANY_FUNDING_LABEL) }
          Icon={ <CompanyFundingStageTagIcon /> }
        >
          <HeaderDescription>
            { translate(STRING_KEYS.COMPANY_FUNDING_STAGE_MENU_DESCRIPTION) }
          </HeaderDescription>
          <TagContainer>
            <Tag text={ fundingStage } />
          </TagContainer>
        </HeaderSection>
        <BaseSection
          title={ translate(STRING_KEYS.MATCH_CARD.EXPLAINABILITY.INFO_MENU.VERIFICATION_SOURCE_SECTION_TITLE) }
          Icon={ <VerifiedIcon /> }
        >
          { translate(STRING_KEYS.MATCH_CARD.EXPLAINABILITY.VERIFIED_FROM_COMPANY_PROFILE_TEXT, { companyName }) }
        </BaseSection>
      </>
    </Container>
  );
};

export default CompanyFundingStageInfoMenu;
